import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M7.98 3.476v3.468l1.607-.43-.96 3.048-.123-.359-.451-1.329-1.357.364-.48.128V3.969l1.765-.493m1.5-1.976L4.716 2.83v7.491l2.369-.634L8.68 14.38l3.16-10.023-2.36.633V1.5Z"
      }
    )
  }
);
export {
  t as Electricity
};
